import script from "./GoodsItem.vue?vue&type=script&setup=true&lang=js"
export * from "./GoodsItem.vue?vue&type=script&setup=true&lang=js"

import "./GoodsItem.vue?vue&type=style&index=0&id=19511b6e&lang=less"

const __exports__ = script;

export default __exports__